import * as React from "react";
import type { SVGProps } from "react";

const SvgMobileMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={18}
    viewBox="0 0 22 18"
    fill="currentColor"
    {...props}
  >
    <path fillRule="evenodd" d="M0 0h22v2H0zm0 8h22v2H0zm0 8h22v2H0z" />
  </svg>
);
export default SvgMobileMenu;
